import { render } from "./StageHistory.vue?vue&type=template&id=db9c7d92"
import script from "./StageHistory.vue?vue&type=script&lang=js"
export * from "./StageHistory.vue?vue&type=script&lang=js"
script.render = render

export default script